export default __webpack_public_path__ + "static/media/fr2.c6eed7e4.jpg";